import { render, staticRenderFns } from "./item-bar.vue?vue&type=template&id=a6bf8108&scoped=true"
import script from "./item-bar.vue?vue&type=script&lang=js"
export * from "./item-bar.vue?vue&type=script&lang=js"
import style0 from "./item-bar.vue?vue&type=style&index=0&id=a6bf8108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bf8108",
  null
  
)

export default component.exports